import * as types from "../types";

const initialState = {
    loading: false,
    reqBid: null,
    resBidSubmit: null,
    error: null
} 

export default function submitBidReducer(state = initialState, action){

    switch(action.type){
        case types.SUBMIT_BID_REQUEST:
            return {
                ...state,
                loading: true,
                reqBid: action.payload.reqBid
            }

        case types.SUBMIT_BID_SUCCESS: 
            return {
                ...state,
                loading: false,
                resBidSubmit: action.payload.resBidSubmit
            }

        case types.SUBMIT_BID_FAILURE: 
            return {
                ...state,
                loading: false,
                reqBid: null,
                resBidSubmit: null,
                error: action.payload.error
        }    

        case types.SUBMIT_BID_RESET: 
        return {
            ...state,
            loading: false,
            reqBid: null,
            resBidSubmit: null,
            error: null
        }  


        default : 
            return state
    }

}